import { render, staticRenderFns } from "./BindingPhone.vue?vue&type=template&id=fb7ae53e&scoped=true&"
import script from "./BindingPhone.vue?vue&type=script&lang=js&"
export * from "./BindingPhone.vue?vue&type=script&lang=js&"
import style0 from "./BindingPhone.vue?vue&type=style&index=0&id=fb7ae53e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7ae53e",
  null
  
)

export default component.exports